@if (showFileInfo) {
  <div>
    <icz-section label="Informace o spisu">
      <icz-entity-info [entity]="file"></icz-entity-info>
    </icz-section>
  </div>
}

<form [formGroup]="form" [waiting]="loadingService.isLoading$(this) | async">
  @if (validationMessage) {
    <icz-alert class="grow mt-8" severity="error" heading="Spis není možné vyřídit" [label]="validationMessage"></icz-alert>
  } @else {
    <div class="row-24 grow">
      <div class="col-8 grow">
        <icz-section label="Jak chcete vyřídit">
          <icz-form-autocomplete label="Způsob vyřízení spisu" formControlName="fileSettlementType"
                                 [options]="fileSettlementTypeOptions"></icz-form-autocomplete>
          @if (isSettlementByOtherMethod) {
            <icz-form-autocomplete label="Jiný způsob vyřízení"
                                   formControlName="settlementMethodId"
                                   [options]="otherSettlementMethodsOptions">
            </icz-form-autocomplete>
          }
          <icz-date-picker class="grow" outputFormat="dateTime"
                           label="Datum vyřízení"
                           formControlName="settlementDate"
                           [selectableDates]="isValidSettlementDate">
            <icz-icon suffix size="small" svgIcon="info"
                      tooltipText="Termín vyřízení nesmí být před datumem vzniku spisu.">
            </icz-icon>
          </icz-date-picker>
          @if (showDocumentSelector) {
            <div>
              <icz-form-autocomplete class="grow"
                                     label="Vyberte ze spisu vyřizující dokument"
                                     formControlName="relatedDocumentId"
                                     searchTermInputPrefix="Název"
                                     [customOptionTemplate]="optionTemplate"
                                     [options]="documentOptions">
              </icz-form-autocomplete>
              <ng-template #optionTemplate let-context>
                <div class="row">
                  <div class="col">
                    <icz-object-class-icon [objectClass]="context.option.data.objectClass" class="mt-2 ml-8 mr-4"></icz-object-class-icon>
                  </div>
                  <div class="col icz-body-1">
                    <span class="ref-number">{{context.option.data.refNumber}}</span><br>
                    {{context.option.label}}
                  </div>
                </div>
              </ng-template>
            </div>
          }
          @if (isSettlementByRecord) {
            <div>
              <icz-form-field class="grow" formControlName="reason" label="Důvod"></icz-form-field>
              <icz-form-field class="grow" formControlName="content" label="Obsah"></icz-form-field>
            </div>
          }
        </icz-section>
        <icz-section label="Uzavření spisu">
          <div class="grow">
            <icz-checkbox label="Společně s vyřízením spis také uzavřít"
                          formControlName="doCloseFile"></icz-checkbox>
            <br>
          </div>
          @if (form.get('doCloseFile')!.value) {
            <icz-date-picker class="grow"
                             label="Datum uzavření" formControlName="closeDate" outputFormat="dateTime"></icz-date-picker>
          }
        </icz-section>
      </div>
      <div class="col-8 grow">
        <icz-section label="Zatřídění">
          <icz-file-type-selector
            [form]="form"
            controlName="fileTypeId"
            [mode]="VisibleClassifiersMode.VALID_AT_GIVEN_DATE"
            [date]="settlementDate"
          ></icz-file-type-selector>
          <icz-entity-class-selector
            [form]="form"
            controlName="entityClassId"
            [showEntityClassesValidAt]="settlementDate"
            [usage]="EntityClassSelectorUsage.OFFICER_CURRENT_WITHOUT_V"
            [selectorEntityClassType]="file?.caseFile ? null : EntityClassType.DOCUMENT_FILE"
          ></icz-entity-class-selector>
          <div class="row grow">
            <icz-form-autocomplete label="Forma spisu" formControlName="fileForm"
                                   [options]="fileFormOptions" class="grow">
            </icz-form-autocomplete>
          </div>
          <div class="row-8 grow">
            <icz-date-picker label="Platnost věcné skupiny od" formControlName="entityClassValidFrom" class="grow" outputFormat="dateTime"></icz-date-picker>
            <icz-date-picker label="Platnost věcné skupiny do" formControlName="entityClassValidTo" class="grow" outputFormat="dateTime"></icz-date-picker>
          </div>
        </icz-section>
      </div>
    </div>
    <div class="row grow">
      <div class="col grow">
        <icz-section class="grow" label="Rešení konfliktů skartačních režimů">
          <div class="row-24 grow">
            <div class="col grow">
              <icz-form-field formControlName="disposalOperationCode" label="Výsledný skartační znak"></icz-form-field>
              <icz-form-autocomplete
                [clearable]="false"
                [options]="retentionTriggerTypesOptions"
                class="grow"
                formControlName="retentionTriggerTypeCode"
                label="Spouštěcí událost"
              ></icz-form-autocomplete>
              @if (isExternalRetentionTriggerTypeWithPeriod()) {
                <icz-ext-retention-trigger-selector
                  [form]="form"
                  [availableExternalRetentionTriggerIds]="form.get('externalRetentionTriggerIds')!.value ?? []"
                ></icz-ext-retention-trigger-selector>
              }
            </div>
            <div class="col grow">
              <div class="row">
                <icz-form-field class="grow" formControlName="disposalYear" label="Předpokládaný rok vyřazení"></icz-form-field>
                <div class="grow"></div>
              </div>

              <div class="row">
                <icz-form-field class="grow" label="Rok spouštěcí události"  formControlName="yearOfRetentionPeriodStart" type="integer"></icz-form-field>
                @if (isRetentionTriggerTypeWithPeriod()) {
                  <icz-form-field class="grow" label="Rok kontroly spouštěcí události"  formControlName="triggerEventCheckYear" type="integer"></icz-form-field>
                }  @else {
                  <div class="grow"></div>
                }
              </div>
            </div>
          </div>
        </icz-section>
      </div>
    </div>
  }
</form>
